import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ItemCounterComponent } from '@spartacus/storefront';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@spartacus/core';

@Component({
    selector: 'app-efa-item-counter',
    templateUrl: './efa-item-counter.component.html',
    imports: [FormsModule, ReactiveFormsModule, TranslatePipe]
})
export class EfaItemCounterComponent extends ItemCounterComponent implements OnInit {

  @Output() isReturnPositionQuantityToReturnChanged = new EventEmitter<boolean>(false);
  ngOnInit(): void {
    // overriding ngOnInit because the super method sets wrongs values to the control if new items are created by cart simulation
  }

  onReturnPositionQuantityToReturnChange(){
  this.isReturnPositionQuantityToReturnChanged.emit(true);
  }
  updateItemQuantityOnEnter(event): void {
    this.control.setValue(event.target.value);
    this.control.markAsDirty();
  }
}
